import React from 'react';
import { SidePanel } from '../ui';
import ControlPage from '../../pages/controls/ControlPage';

export default function ControlOverlay({ open, onClose, control_id }) {
    if (!open) return null;

    return (
        <SidePanel
            onClose={onClose}
            overlayZIndex="z-[400]"
            resizable
            defaultWidth={Math.round(window.innerWidth * 0.6)}
            minWidth={420}
            className="rounded-tl-2xl"
        >
            <ControlPage
                embedded
                embeddedId={control_id}
                onClose={onClose}
            />
        </SidePanel>
    );
}
